// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1832":"59487272","2786":"c874fa2b","5782":"b6d70103"}[chunkId] + ".chunk.css";
};